import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import DashSidebar from '../../components/dashboard/DashSidebar'
import DashOverView from '../../components/dashboard/DashOverView'
import UsersTab from '../../components/dashboard/UsersTab'
import OrdersTab from '../../components/dashboard/OrdersTab'
import ProductsTab from '../../components/dashboard/ProductsTab'
import { useNavigate } from 'react-router-dom'
import StoresTab from '../../components/dashboard/StoresTab'
import RefundsTab from '../../components/orders/RefundsTabs'

function AdminDashBoard() {
    const [tab, setTab] = useState(0)
    const navigate = useNavigate();

    function changeTab(val) {
        setTab(val)
        window.scrollTo(0, 0);
        const url = new URL(window.location);
        url.search = ''
        navigate(url.pathname, { replace: true });
    }
    return (
        <div className='px-6 py-4 container mx-auto'>
            <Helmet>
                <title>Admin Dashboard - {utils.siteName}</title>
            </Helmet>
            <div className="flex flex-col md:flex-row gap-8 lg:gap-12">
                <DashSidebar
                    tab={tab}
                    changeTab={changeTab} />
                <div className="flex-1">
                    {tab === 0 && (
                        <DashOverView />
                    )}
                    {tab === 1 && (
                        <UsersTab />
                    )}
                    {tab === 2 && (
                        <OrdersTab />
                    )}
                    {tab === 3 && (
                        <ProductsTab />
                    )}
                    {tab === 4 && (
                        <StoresTab />
                    )}
                    {tab === 5 && (
                        <RefundsTab />
                    )}
                </div>
            </div>
        </div>
    )
}

export default AdminDashBoard